import React from "react";

const FAQs = () => {
   return(<h1>This is FAQs</h1>);
};
export default FAQs;